<div id="container" data-cy="insurance-select-fee-container">

  <div id="header" data-cy="insurance-select-fee-header">
    <p data-cy="insurance-select-fee-title">Select a Fee Schedule</p>
  </div>

  <div id="body" data-cy="insurance-select-fee-body">

    <dx-list
      [dataSource]="listOfFeeSchedules"
      [searchEnabled]="true"
      searchExpr="FeeScheduleName"
      searchMode="contains"
      [selectionMode]="'single'"
      [pageLoadMode]="'scroll'"
      (onSelectionChanged)="onFeeSelectionChanged($event)"
      data-cy="insurance-select-fee-list"
    >
      <div *dxTemplate="let data of 'item'" data-cy="insurance-select-fee-list-item">
        <div data-cy="insurance-select-fee-item-name">{{ data.FeeScheduleName }}</div>
      </div>
    </dx-list>


  </div>

  <div id="footer" data-cy="insurance-select-fee-footer">
    <dx-button style="margin-right: 4px;"
      stylingMode="contained"
      text="OK"
      type="default"
      [width]="120"
      (onClick)="onClose()"
      data-cy="insurance-select-fee-ok-button"
    ></dx-button>
    <dx-button style="margin-right: 4px;"
      stylingMode="contained"
      text="Cancel"
      type="default"
      [width]="120"
      (onClick)="onCancel()"
      data-cy="insurance-select-fee-cancel-button"
    >
    </dx-button>

  </div>


</div>
